import {Dispatch} from "redux";
import {ActionType} from "../action_type";
import {Action} from "../actions/fetchGuildListAction";
import {logOut} from "../../helper/helper";
import guildService from "../../services/guild.service";

export const fetchGuildList = (sort = "DESC") => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.FETCH_GUILD_LIST,
    });

    try {
      const {data} = await guildService.guilds({
        lang: "fa",
        pageSize: 10,
        sort: sort,
        sortKey: "visitDate",
      })

      // const names: string[] = data.objects.map((result: any) => {
      //   return result.package.name;
      // });

      dispatch({
        type: ActionType.FETCH_GUILD_LIST_SUCCESS,
        payload: data.content,
      });
    } catch (error: any) {
      if (error.response) {
        // Request made and server responded
        if (error.response.status === 401) {
          console.log("error status with 401");
          logOut();
        }
        if (error.response.status === 400) {
          console.log("error status with 400");
          logOut();
        }
      } else if (error.request) {
        console.log("The request was made but no response was received");
        dispatch({
          type: ActionType.FETCH_GUILD_LIST_ERROR,
          payload: error.message,
        });
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
      console.log("this is error from ac fetch guild list => ", error);
      dispatch({
        type: ActionType.FETCH_GUILD_LIST_ERROR,
        payload: error.message,
      });
    }
  };
};
